import { urls } from 'utils/urls';

import { buildApiRequest } from 'utils/api';

export function getCommentsRequest(params) {
  return buildApiRequest('GET', urls.getComments, {
    'demand-id': params.params.demandId,
    context: params.params.context,
  });
}

export function getSubStageDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getDemands}/${params.params.demandId}/sub-status`);
}

export function postSubStageDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${payload.demandId}/sub-status`, {
    ...payload.payload,
  });
}

export function getAuditRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/${params.consignmentId}/state-details`);
}

export function postCommentRequest(payload) {
  return buildApiRequest('POST', urls.getComments, payload);
}
